import http from '@/requests/http'

class Project {
  static all (params) {
    return http.post('projects/index', params)
  }
  static store (params) {
    return http.post('projects/store', params)
  }
  static view (params) {
    return http.post('projects/view', params)
  }
  static update (params) {
    return http.post('projects/update', params)
  }
  static destroy (params) {
    return http.post('projects/destroy', params)
  }
}

export default Project
